import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=2055564b&scoped=true"
import script from "./pushMessage.vue?vue&type=script&lang=js"
export * from "./pushMessage.vue?vue&type=script&lang=js"
import style0 from "./pushMessage.vue?vue&type=style&index=0&id=2055564b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055564b",
  null
  
)

export default component.exports